<template>
  <div class="socialization-win-container">
    <!-- 加油站信息 -->
    <Modal
      :show="true"
      title=""
      width="320px"
      v-if="infoType == 4"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div style="width: 312px;overflow: hidden;">
            <div class="font-left" :class="detailInfo.name && detailInfo.name.length >=  14 ? 'title-animation':''">{{detailInfo.name}}</div>
          </div>
          <img class="close" @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-tags" v-if="detailInfo.rate &&  detailInfo.rate >= 0.5">
          <div class="tag-authentication">评分</div>
          <img v-for="inde in (detailInfo.rate ? Math.round(detailInfo.rate) : 0)" :key="index" class="icon-star" src="../../../assets/images/socializationIcon/map-icon/icon_star.png">
          <div style="margin-left: 4px;font-size: 14px;">{{detailInfo.rate &&  detailInfo.rate >= 0.5 ? Math.round(detailInfo.rate) + '星' : ''}}</div>
        </div>
        <div v-else style="height: 8px;"></div>
        <div class="info-detail-item">
          <div class="label label-oil">营业时间:</div>
          <div class="value">{{ detailInfo.openTime || '--' }}</div>
        </div>
        <div class="info-detail-item ">
          <div class="label label-oil">主要服务:</div>
          <div class="value four-ellipsis">{{ detailInfo.mainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item ">
          <div class="label label-oil" style="text-align: right;">位置:</div>
          <div class="value">{{ detailInfo.address || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!-- 通用站信息 -->
    <Modal
      :show="true"
      title=""
      width="332px"
      v-if="infoType == '0' || infoType == '1' || infoType == '2' || infoType == '3' "
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div style="width: 302px;overflow: hidden;">
            <div class="font-left"  :class="detailInfo.name && detailInfo.name.length >=  14 ? 'title-animation':''">{{detailInfo.name}}</div>
          </div>
          <img class="close" @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-tags">
          <template v-if="detailInfo.stationStatus == 1">
            <div class="tag-authentication">已认证</div>
            <img v-for="inde in (detailInfo.rate ? Math.round(detailInfo.rate) : 0)" :key="index" class="icon-star" src="../../../assets/images/socializationIcon/map-icon/icon_star.png">
            <div style="margin-left: 4px;font-size: 14px;">{{detailInfo.rate &&  detailInfo.rate > 0 ? Math.round(detailInfo.rate) + '星' : ''}}</div>
          </template>
          <template v-else>
            <div class="tag-no-authentication">未认证</div>
          </template>
        </div>
        <div class="info-detail-item">
          <div class="label label-farm">营业时间:</div>
          <div class="value">{{ detailInfo.openTime || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-farm">站点位置:</div>
          <div class="value">{{ detailInfo.address || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-farm">主要服务:</div>
          <div class="value four-ellipsis">{{ detailInfo.mainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-farm">公司简介:</div>
          <div class="value four-ellipsis">{{ detailInfo.introduction || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-farm">联系方式:</div>
          <div class="value">{{ detailInfo.phone || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!--农活信息 -->
    <Modal
      :show="true"
      title=""
      width="332px"
      v-if="infoType == 7"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div>农活详情</div>
          <img class="close"  @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-item" style="margin-top: 10px">
          <div class="label label-work">作业类型:</div>
          <div class="value">{{ detailInfo.jobTypeName || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-work">作业地点:</div>
          <div class="value">{{ detailInfo.address || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-work">预估作业量(亩):</div>
          <div class="value">{{ detailInfo.estimateWorkload || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-work">发布人:</div>
          <div class="value">{{ detailInfo.name || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-work">联系电话:</div>
          <div class="value">{{ detailInfo.phone || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-work">工作内容:</div>
          <div class="value">{{ detailInfo.introduction || '--' }}</div>
        </div>
        <div class="info-detail-item"  style="margin-bottom: 10px">
          <div class="label label-work">发布时间:</div>
          <div class="value">{{ detailInfo.createTime || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!--机手信息 -->
    <Modal
      :show="true"
      title=""
      width="428px"
      v-if="infoType == 5"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div>机手详情</div>
          <img class="close" @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-person">
          <img :src="detailInfo.avatar ? detailInfo.avatar : require(`../../../assets/images/socializationIcon/map-icon/photo_js.png`)" alt="" srcset="">
          <div style="flex:1;">
            <div class="info-detail-item">
              <div class="label label-oil">机手姓名:</div>
              <div class="value">{{ detailInfo.name || '--' }}</div>
            </div>
            <div class="info-detail-item">
              <div class="label label-oil">身份证号:</div>
              <div class="value">{{ detailInfo.idCard	 || '--' }}</div>
            </div>
            <div class="info-detail-item">
              <div class="label label-oil">联系电话:</div>
              <div class="value">{{ detailInfo.phone || '--' }}</div>
            </div>
            <div style="display: flex;justify-content: space-between;width: 278px;">
              <div class="info-detail-item">
                <div class="label label-oil">准驾车型:</div>
                <div class="value-font">{{ detailInfo.driverType || '--' }}</div>
              </div>
              <div class="info-detail-item">
                <div class="label" style="width: 34px;">驾龄:</div>
                <div class="value-font">{{ detailInfo.driveYears || '--' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">擅长工种:</div>
          <div class="value value-person">{{ detailInfo.mainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">机手地址:</div>
          <div class="value value-person">{{ detailInfo.address || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">当前位置:</div>
          <div class="value value-person">{{ detailInfo.location || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">有效起始日期:</div>
          <div class="value value-person">{{ (detailInfo.licenseFirstDate && detailInfo.licenseFirstDate.split(' ')[0]) || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">有效结束日期:</div>
          <div class="value value-person">{{ (detailInfo.licenseEndDate && detailInfo.licenseEndDate.split(' ')[0]) || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</div>
          <div class="value value-person">{{ detailInfo.introduction || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!--帮手信息 -->
    <Modal
      :show="true"
      title=""
      width="428px"
      v-if="infoType == 6"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div>帮手详情</div>
          <img class="close"  @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-person">
          <img :src="detailInfo.helperAvatar ? detailInfo.helperAvatar : require(`../../../assets/images/socializationIcon/map-icon/photo_bs.png`)" alt="" srcset="">
          <div style="flex:1;display: flex;flex-direction: column;">
            <div class="info-detail-item" style="flex: 1;">
              <div class="label label-oil">帮手姓名:</div>
              <div class="value">{{ detailInfo.helperName || '--' }}</div>
            </div>
            <div class="info-detail-item" style="flex: 1;">
              <div class="label label-oil">身份证号:</div>
              <div class="value">{{ detailInfo.helperIdCard || '--' }}</div>
            </div>
            <div class="info-detail-item" style="flex: 1;">
              <div class="label label-oil">联系电话:</div>
              <div class="value">{{ detailInfo.helperPhone || '--' }}</div>
            </div>
          </div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">擅长工种:</div>
          <div class="value value-person" style="width: 308px">{{ detailInfo.helperMainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">当前位置:</div>
          <div class="value value-person" style="width: 308px">{{ detailInfo.helperLocation || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</div>
          <div class="value value-person"  style="width: 308px">{{ detailInfo.helperIntroduction || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!--既是机手又是帮手信息 -->
    <Modal
      :show="true"
      title=""
      width="428px"
      v-if="infoType == '5,6'"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div>机手/帮手详情</div>
          <img class="close" @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-person">
          <img :src="detailInfo.avatar ? detailInfo.avatar : require(`../../../assets/images/socializationIcon/map-icon/photo_js.png`)" alt="" srcset="">
          <div style="flex:1;">
            <div class="info-detail-item">
              <div class="label label-oil">机手姓名:</div>
              <div class="value">{{ detailInfo.name || '--' }}</div>
            </div>
            <div class="info-detail-item">
              <div class="label label-oil">身份证号:</div>
              <div class="value">{{ detailInfo.idCard	 || '--' }}</div>
            </div>
            <div class="info-detail-item">
              <div class="label label-oil">联系电话:</div>
              <div class="value">{{ detailInfo.phone || '--' }}</div>
            </div>
            <div style="display: flex;justify-content: space-between;width: 278px;">
              <div class="info-detail-item">
                <div class="label label-oil">准驾车型:</div>
                <div class="value-font">{{ detailInfo.driverType || '--' }}</div>
              </div>
              <div class="info-detail-item">
                <div class="label label-oil" style="width: 34px;">驾龄:</div>
                <div class="value-font">{{ detailInfo.driveYears || '--' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">擅长工种:</div>
          <div class="value value-person">{{ detailInfo.mainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">机手地址:</div>
          <div class="value value-person">{{ detailInfo.address || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">当前位置:</div>
          <div class="value value-person">{{ detailInfo.location || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">有效起始日期:</div>
          <div class="value">{{ (detailInfo.licenseFirstDate && detailInfo.licenseFirstDate.split(' ')[0]) || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">有效结束日期:</div>
          <div class="value">{{ (detailInfo.licenseEndDate && detailInfo.licenseEndDate.split(' ')[0]) || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-person">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</div>
          <div class="value value-person">{{ detailInfo.introduction || '--' }}</div>
        </div>
        <div class="line"></div>
        <div class="info-detail-person">
          <img :src="detailInfo.helperAvatar ? detailInfo.helperAvatar : require(`../../../assets/images/socializationIcon/map-icon/photo_bs.png`)" alt="" srcset="">
          <div style="display: flex;flex-direction: column;">
            <div class="info-detail-item" style="flex:1;">
              <div class="label label-oil">帮手姓名:</div>
              <div class="value">{{ detailInfo.helperName || '--' }}</div>
            </div>
            <div class="info-detail-item" style="flex:1;">
              <div class="label label-oil">身份证号:</div>
              <div class="value">{{ detailInfo.helperIdCard || '--' }}</div>
            </div>
            <div class="info-detail-item" style="flex:1;">
              <div class="label label-oil">联系电话:</div>
              <div class="value">{{ detailInfo.helperPhone || '--' }}</div>
            </div>
          </div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">擅长工种:</div>
          <div class="value value-person">{{ detailInfo.helperMainBusiness || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">当前位置:</div>
          <div class="value value-person">{{ detailInfo.helperLocation || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</div>
          <div class="value value-person">{{ detailInfo.helperIntroduction || '--' }}</div>
        </div>
      </div>
    </Modal>
    <!-- 粮食经纪人 -->
    <Modal
      :show="true"
      title=""
      width="428px"
      v-if="infoType == '9'"
    >
      <div
        slot="content"
        class="modal-content"
      >
        <div class="info-detail-top">
          <div style="width: 420px;overflow: hidden;">
            <div class="font-left">粮食经纪人</div>
          </div>
          <img class="close" @click="close" src="../../../assets/images/socializationIcon/map-icon/icon_con_close.png" alt="" srcset="">
        </div>
        <div class="info-detail-item" style="margin-top: 8px;">
          <div class="label label-oil">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
          <div class="value">{{ detailInfo.name || '--' }}</div>
        </div>
        <div class="info-detail-item ">
          <div class="label label-oil">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市：</div>
          <div class="value four-ellipsis">{{ detailInfo.areaName || '--' }}</div>
        </div>
        <div class="info-detail-item ">
          <div class="label label-oil">详细地址:</div>
          <div class="value value-capability">{{ detailInfo.address || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">联系方式:</div>
          <div class="value">{{ detailInfo.phone || '--' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">能&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;力:</div>
          <div class="value value-capability">{{ detailInfo.abilityName || '' }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label label-oil">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</div>
          <div class="value value-capability">{{ detailInfo.introduction || '--' }}</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@components/socializationModal.vue";
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
    // 0-经销商,1-维修站，2-转运站，3-农资站，4-加油站，5-机手，6-帮手，7-农活 5,6既是机手又是帮手, 9-粮食经纪人
    infoType: {
      type: String,
      default: () => {
        return '2';
      },
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  components: {
    Modal,
  },
  methods: {
    close() {
      console.log('infowindow触发close');
      this.vmm.closeWindow();
    },
  },
};
</script>

<style scoped lang="scss">
.socialization-win-container {
  width: 460px;
  .modal-content {
    padding-bottom: 10px;
    .info-title {
      margin: 5px 0px;
      color: #ffff9a;
      text-align: left;
      margin-left: -1em;
    }
    .info-detail-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 38px;
      padding: 0 10px 0 12px;
      background: linear-gradient(90deg, #09B051 0%, rgba(9,173,80,0.33) 100%);
      box-shadow: 0px -6px 13px 0px rgba(0,255,110,0.22);
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      position: relative;
      div {
        margin-right: 30px;
        .font-left {
          text-align: left;
        }
      }
      .close {
        cursor: pointer;
        position: absolute;
        top: 13px;
        right: 13px;
        pointer-events: auto!important;
      }
    }
    .info-detail-tags {
      display: flex;
      align-items: center;
      margin: 8px 16px 2px 16px;
      font-size: 12px;
      color: rgba(255, 159, 36, 1);
      div {
        margin-right: 4px;
      }
      .icon-star {
        width: 12px;
        height: 12px;
      }
      .tag-authentication {
        width: 48px;
        height: 19px;
        margin-right: 8px;
        background: #C49300;
        border-radius: 4px;
        border: 1px solid #FCDB77;
        color: #FFFFFF;
        text-shadow: 0px 1px 0px #894B00;
        font-style: italic;
      }
      .tag-no-authentication {
        width: 48px;
        height: 19px;
        margin-right: 8px;
        background: rgba(204, 204, 204, 1);
        border-radius: 4px;
        border: 1px solid #F1F1F1;
        color: rgba(102, 102, 102, 1);
        font-style: italic;
      }
    }
    .info-detail-person {
      display: flex;
      margin: 16px 16px 8px  16px;
      img {
        width: 96px;
        height: 96px;
        border-radius: 48px;
        border: 2px solid #E5E5E5;
      }
    }
    .info-detail-item {
      display: flex;
      line-height: 26px;
      padding: 0 16px;
      .title-label {
        font-size: 14px;
      }
      .label {
        width: 96px;
        text-align: left;
        font-size: 14px;
        color: rgba(233, 240, 247, 1);
        margin-right: 8px;
      }
      .label-oil {
        width: 64px;
      }
      .label-transport {
        width: 99px;
        text-align: right;
      }
      .label-work {
        width: 115px;
        text-align: right;
      }
      .label-farm {
        width: 74px;
      }
      .label-person {
        width: 104px;
        text-align: right;
      }
      .value {
        width: 220px;
        color: rgba(13, 255, 169, 1);
        line-height: 26px;
        text-align: left;
        font-size: 14px;
        word-break:break-all;
      }
      .value-font {
        color: rgba(13, 255, 169, 1);
        line-height: 26px;
        text-align: left;
        font-size: 14px;
        word-break:break-all;
      }
      .value-person  {
        width: 280px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .value-capability {
        width: 324px;
      }
    }

  }
}

.title-animation {
  width: 260px;
  white-space: nowrap;
  animation: scroll 6s linear infinite; /* 动画名称、持续时间、动画速度曲线、是否循环 */  
}

.four-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line {
  margin: 10px 16px 0 16px;
  width: 392px;
  border: 1px solid #00D75D; 
}

@keyframes scroll {  
  from {  
    transform: translateX(50%); /* 从右边开始 */  
  }  
  to {  
    transform: translateX(-100%); /* 滚动到左边，然后由于无限循环，会从右边重新开始 */  
  }  
}  
</style>
